/**
 * SmoothScroll
 * data-smooth-scroll属性を持つアンカーリンクのクリック時にスムーススクロールを実行
 * prefers-reduced-motion対応、フォーカス管理を含む
 *
 * @example
 * <a href="#section" data-smooth-scroll>セクションへ</a>
 * <a href="#section" data-smooth-scroll="disabled">スクロール無効</a>
 */
export class SmoothScroll {
  constructor() {
    /** @type {MediaQueryList} */
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.handleClick = this.handleClick.bind(this);
    document.addEventListener('click', this.handleClick);
  }

  /**
   * prefers-reduced-motionの設定に基づくスクロール動作を返す
   * @returns {'smooth' | 'instant'}
   */
  getScrollBehavior() {
    return this.reducedMotion.matches ? 'instant' : 'smooth';
  }

  /**
   * クリックイベントハンドラ（イベント委譲）
   * @param {MouseEvent} event
   */
  handleClick(event) {
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
      return;

    const clickTarget = /** @type {Element|null} */ (event.target);
    if (!clickTarget) return;

    const anchor = /** @type {HTMLAnchorElement|null} */ (
      clickTarget.closest('[data-smooth-scroll]')
    );
    if (!anchor) return;
    if (anchor.dataset.smoothScroll === 'disabled') return;
    if (
      anchor.getAttribute('role') === 'tab' ||
      anchor.getAttribute('role') === 'button'
    )
      return;

    const href = anchor.getAttribute('href') || '';
    const hash = anchor.hash || href;
    if (!hash || !hash.startsWith('#')) return;

    event.preventDefault();

    const behavior = this.getScrollBehavior();

    // #top, #, href="#" の場合はページ先頭へ
    if (hash === '#top' || hash === '#') {
      window.scrollTo({ top: 0, behavior });
      return;
    }

    const target = document.getElementById(hash.slice(1));
    if (!target) return;

    target.scrollIntoView({ behavior, block: 'start' });

    // フォーカス管理: tabindexがない要素には一時的に付与
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
      target.addEventListener(
        'blur',
        () => target.removeAttribute('tabindex'),
        { once: true },
      );
    }
    target.focus({ preventScroll: true });
  }

  /** 破棄 */
  destroy() {
    document.removeEventListener('click', this.handleClick);
  }
}
